import React, { memo } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    styled,
    Typography,
} from '@mui/material';
import CostIcon from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/CostIcon';
import Flex from 'ui/Flex/Flex';
import { CostPerYearT } from '../../../GVTData/helpers/hooks/gvtData';

type TotalCostProps = {
    costPerYear: CostPerYearT;
    totalCost: number;
    isLoading: boolean;
    label: string;
    endAdornment?: React.ReactNode;
};

export const StyAccordionCost = styled(Accordion)(() => ({
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    margin: 0,
    width: 'fit-content',
    '&::before': {
        display: 'none',
    },
    '&.Mui-expanded': {
        margin: 0,
        minHeight: 'unset',
    },
}));

export const StyAccordionSummaryCost = styled(AccordionSummary)(() => ({
    padding: 0,
    margin: 0,
    minHeight: 'unset',
    '&.Mui-expanded': {
        margin: 0,
        minHeight: 'unset',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
        padding: 0,
        alignSelf: 'flex-end',
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        padding: 0,
    },
    '&.MuiAccordionSummary-content': {
        margin: 0,
    },
    '& .MuiAccordionSummary-content.MuiAccordionSummary-contentGutters': {
        margin: 0,
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: 0,
        minHeight: 'none',
    },
}));

const TotalCost = ({
    costPerYear,
    totalCost,
    isLoading,
    label,
    endAdornment = null,
}: TotalCostProps) => (
    <Flex direction="column" justifyContent="flex-start">
        <Flex
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            gap={1}
            height="1rem"
            marginBottom="1rem"
        >
            <Typography variant="body1" sx={{ fontSize: '12px' }}>
                {label}
            </Typography>
            {endAdornment}
        </Flex>
        <StyAccordionCost>
            <StyAccordionSummaryCost>
                <CostIcon
                    value={totalCost}
                    isLoading={isLoading}
                    isInAccordion={true}
                />
            </StyAccordionSummaryCost>
            <AccordionDetails
                sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
            >
                {costPerYear &&
                    Object.entries(costPerYear).map(([year, cost]) => (
                        <CostIcon
                            key={year}
                            value={cost}
                            isLoading={isLoading}
                            year={Number(year)}
                        />
                    ))}
            </AccordionDetails>
        </StyAccordionCost>
    </Flex>
);

export default memo(TotalCost);
